export class MergeKeyDetailAdditionRequest {
  doNos: string[];
  mergeKey: string | null | undefined;
  facility: string | null;
  userId: string | null;
  mixFacility : boolean | null;

  constructor() {
    this.doNos = [];
    this.mergeKey = null;
    this.facility = null;
    this.userId = null;
    this.mixFacility = false;
  }
}
